/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import styles from "../../Styles/CreatorDash/styles.module.css";

import Playlist from "../PlaylistView/Playlist2";
import axios from "axios";
import Loader from "react-js-loader";
import { API } from "../../backend";
import UploadPlaylist from "../Modals/UploadPlaylist";

const Courses = ({ menu, setMenu, setList, list }) => {
  const [playlist, setPlaylist] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadError, setLoadError] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(async () => {
    setLoading(true);
    var config = {
      method: "get",
      url: `${API}/playlist/getAll`,
      headers: {
        Authorization: `Bearer ${JSON.parse(
          localStorage.getItem("_access_token")
        )}`,
      },
    };

    try {
      axios(config)
        .then(function (response) {
          console.log(response?.data?.data, "response");
          if (response.status === 200) {
            setPlaylist(response?.data?.data);
            setLoading(false);
          } else {
            setLoading(false);
          }
        })
        .catch(function (error) {
          console.log(error);
          setLoadError(true);
        });
    } catch (error) {
      setLoadError(true);
    }
  }, []);
  console.log(playlist, "playlist");

  return (
    <>
      {loadError ? (
        <div className={styles.error}>Error Occured here</div>
      ) : (
        <div className={styles.course}>
          {!loading && playlist.length === 0 ? (
            <div className={styles.noCourse}>
              <p>No Courses here... 😢, </p>Click{" "}
              <span onClick={() => setOpen(true)}>here</span> to upload
            </div>
          ) : (
            <div className={styles.cour}>
              {playlist.map((playlist) => (
                <Playlist
                  playlist={playlist}
                  menu={menu}
                  setMenu={setMenu}
                  key={playlist._id}
                  setList={setList}
                  list={list}
                />
              ))}
            </div>
          )}
          {loading && (
            <Loader
              type="bubble-top"
              bgColor={"#000000"}
              color={"#000000"}
              size={100}
              title={"Loading Playlists"}
            />
          )}
          {open && <UploadPlaylist open={open} setOpen={setOpen} />}
        </div>
      )}
    </>
  );
};
export default Courses;
